// extracted by mini-css-extract-plugin
export default {"wrapper":"Contact_wrapper__G8O7X","title":"Contact_title__evB1T","media":"Contact_media__1zWyj","mediaLink":"Contact_mediaLink__opLSe","logo-overlay":"Contact_logo-overlay__FjJhm"};